import React from 'react';
import { useTranslation } from 'react-i18next';
import HeroImage from '../../../../assets/images/services/gaming-license/nauru/hero-image.png'
import BreadCrumbs from "../../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../../components/Constant/HeroRightImage/HeroRightImage";
import PageList from "../../../../components/Constant/List/List";
import { GoDotFill } from "react-icons/go";
import CTA from "../../../../components/Constant/cta/CTA";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Button from "../../../../components/Constant/button/Button";
import SEO from "../../../../utils/SEO";

function GamingLicenseNauru () {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.gaming-license-nauru.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });
    const dots = (k) => (obj(k) || []).map((item) => ({ ...item, icon: GoDotFill }));

    const BreadCrumbsData = [
        { name: tp('breadcrumb.home', 'Offshore Advisory'), link: '/' },
        { name: tp('breadcrumb.self', 'Gaming License – Nauru'), link: '/gaming-license-nauru' },
    ];

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                url="/gaming-license-nauru"
            />

            <section className='banking-license-section section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='banking-license-container container'>

                    <h1 className='section-title'>
                        {tp('h1')}
                    </h1>

                    <div className='grid-container'>
                        <div className='flex-start'>
                            <br/>

                            <h3 className='page-subtitle'>
                                {tp('hero.subtitle')}
                            </h3>
                            <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('hero.p1') }} />
                            <h3 className='page-subtitle'>{tp('hero.consultSubtitle')}</h3>
                            <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('hero.consultP') }} />
                            <Button
                                text={tp('hero.button')}
                                link="/contact"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImage} />
                    </div>

                    <div className='flex-start'>
                        <br/>
                        <h3 className='page-title'>{tp('overview.title')}</h3>
                        <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('overview.p1') }} />
                        <PageList items={dots('overview.items')} />
                        <p className='page-paragraph'>
                            {tp('overview.after')}
                        </p>

                        <h3 className='page-title'>{tp('whyChoose.title')}</h3>
                        <PageList items={dots('whyChoose.items')} />

                        <h3 className='page-title'>{tp('categories.title')}</h3>
                        <p className='page-paragraph'>
                            {tp('categories.lead')}
                        </p>
                        {(obj('categories.groups') || []).map((group, i) => (
                            <React.Fragment key={i}>
                                <PageList items={(group.head || []).map((item) => ({ ...item, icon: GoDotFill }))} />
                                {group.suitable && group.suitable.length > 0 && (
                                    <>
                                        <p className='page-paragraph'>{tp('categories.suitableLabel')}</p>
                                        <PageList items={group.suitable.map((item) => ({ ...item, icon: GoDotFill }))} />
                                    </>
                                )}
                            </React.Fragment>
                        ))}
                        <p className='page-paragraph'>
                            {tp('categories.after')}
                        </p>

                        <h3 className='page-title'>{tp('who.title')}</h3>
                        <p className='page-paragraph'>
                            {tp('who.lead')}
                        </p>
                        <PageList items={dots('who.items')} />

                        <h3 className='page-title'>{tp('requirements.title')}</h3>
                        <p className='page-paragraph'>
                            {tp('requirements.lead')}
                        </p>
                        <PageList items={dots('requirements.company')} />
                        <PageList items={dots('requirements.companyTypes')} />
                        <PageList items={dots('requirements.ownershipAndPlan')} />
                        <PageList items={dots('requirements.planItems')} />
                        <PageList items={dots('requirements.amlHead')} />
                        <PageList items={dots('requirements.amlItems')} />
                        <PageList items={dots('requirements.others')} />

                        <h3 className='page-title'>{tp('compliance.title')}</h3>
                        <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('compliance.p1') }} />
                        <PageList items={dots('compliance.items')} />
                        <p className='page-paragraph'>
                            {tp('compliance.after')}
                        </p>

                        <h3 className='page-title'>{tp('banking.title')}</h3>
                        <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('banking.p1') }} />
                        <PageList items={dots('banking.items')} />
                        <p className='page-paragraph'>
                            {tp('banking.after')}
                        </p>

                        <h3 className='page-title'>{tp('application.title')}</h3>
                        <PageList items={dots('application.items')} />

                        <h3 className='page-title'>{tp('timeline.title')}</h3>
                        <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('timeline.p1') }} />
                        <PageList items={dots('timeline.items')} />
                        <p className='page-paragraph'>
                            {tp('timeline.after')}
                        </p>

                        <h3 className='page-title'>{tp('costs.title')}</h3>
                        <p className='page-paragraph'>
                            {tp('costs.lead')}
                        </p>
                        <PageList items={dots('costs.items')} />
                        <p className='page-paragraph'>
                            {tp('costs.after')}
                        </p>

                        <h3 className='page-title'>{tp('market.title')}</h3>
                        <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('market.p1') }} />

                        <FAQList data={obj('faq.items')} title={tp('faq.title')}/>

                        <h3 className='page-title'>{tp('disclaimer.title')}</h3>
                        <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('disclaimer.p1') }} />
                    </div>

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/contact"
                    />
                </div>
            </section>
        </main>
    );
}

export default GamingLicenseNauru;
